var exports = {
  "k": "x7be19a29--53fa37--container",
  "y": "x7be19a29--53fa37--links",
};

module.exports = exports;
